import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { useGetMenu } from "./hooks/useHome";
import "./styles.scss";
import { useConfigureFooter } from "~hooks/useHelpers";
import { ApoioVendMais, Telefones, VendMais, VotorantimLogo } from "~misc/png_logos";
import PdfApoio from "../../misc/imgs/documentacao_de_apoio_vendMais.pdf";
import PdfGuiaProduto from "../../misc/imgs/guia_produtos.pdf";
import useLogAcessoManual from "~fetchs/useLogAcessoManual";
import ModalImage from "~components/Modal/ModalImage";
import useModalResponse from "~components/Modal/hooks/useModalResponse";

const Links = () => {

    const {
    isModalOpen,
    closeModal,
    openModal,

  } = useModalResponse();


  const data = useGetMenu();
  useConfigureFooter({ notDeveloped: false });
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { logarAcesso } = useLogAcessoManual();
  const handleClick = (pathname) => {
    logarAcesso(pathname);
  };






  return (
    <>
      <div className="flex items-center justify-center py-5 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 tb:grid-cols-4 xl:grid-cols-5 gap-[2rem] justify-center">
        <Link
           to={PdfGuiaProduto}
          onClick={() => handleClick("guia-produtos")}
           target="_blank" download>
            <div
              className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}
            >
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                 <VotorantimLogo />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Guia de Produtos VC</h2>
              </div>
            </div>
          </Link>
          <Link
            onClick={() => handleClick("apresentacao")}
            to="https://votorantimindustrial.sharepoint.com/teams/ProjetoHUB/Documentos%20Compartilhados/Forms/AllItems.aspx?id=%2Fteams%2FProjetoHUB%2FDocumentos%20Compartilhados%2FGeneral%2F3%2E%20Execu%C3%A7%C3%A3o%2FTREINAMENTOS%2FAcesso%20Coordenadores&viewid=3326de0a%2Db4b7%2D4eda%2D8a71%2D319ef82c91e5"
            target="_blank"
          >
            <div
              className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}
            >
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <VendMais />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Apresentações VenD+</h2>
              </div>
            </div>
          </Link>
          <Link
           to={PdfApoio}
          onClick={() => handleClick("material-de-apoio")}
           target="_blank" download>
            <div
              className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}
            >
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <ApoioVendMais />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Material de Apoio</h2>
              </div>
            </div>
          </Link>
          {data &&
            data
              .filter((item) => item.type)
              .map((item, index) => (
                <Link
                  to={item.disabled ? "#" : item.route}
                  key={index}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  target={item.target}
                >
                  <div
                    className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center ${
                      hoveredIndex === index ? "hovered" : ""
                    }`}
                    onClick={() => handleClick(item.tag)}
                  >
                    <div className="flex justify-center">
                      <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        {item.icon}
                      </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                      <h2 className="text-xl font-semibold mb-2">{item.name}</h2>
                    </div>
                  </div>
                </Link>
              ))}

             <div
            onClick={() => openModal()}


          >
            <div
              className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}
            >
              <div className="flex justify-center">
                <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                  <VendMais />
                </div>
              </div>
              <div className="text-center relative portrait:mt-5 mt-8 w-full">
                <h2 className="text-xl font-semibold mb-2">Telefones úteis</h2>
              </div>
            </div>
          </div>
        </div>
      </div>


      <ModalImage  isOpen={isModalOpen}
        closeModal={closeModal}>
        <Telefones />
      </ModalImage>
    </>
  );
};

export default Links;
